import { FC } from "react";

const CardDivider: FC<{ showDivider: boolean }> = ({ showDivider }) => {
  return showDivider ? (
    <hr className="w-full border-t border-fds-disable my-1.5 md:my-2.5" />
  ) : null;
};

export default CardDivider;
